import React from 'react';
import { Card, Col, Container, Row } from 'reactstrap';

// Import Images
import joinPage from "../../assets/images/gallium/joinPage.jpg";
import joinCode from "../../assets/images/gallium/joinCode.jpg";

import FeatherIcon from 'feather-icons-react/build/FeatherIcon';

const Hypervisor = () => {
    return (
        <React.Fragment>

            <section className="section pt-4 pb-4" id="hypervisor">
                <Container>
                    <Row className="align-items-center gy-4 mb-5">
                        <Col lg={6} className="order-2 order-lg-1">
                            <div className="text-muted">
                                <h5 className="fs-12 text-uppercase text-success">Cloud-Managed Hypervisor</h5>
                                <h4 className="mb-3">Gallium Runs on Your Servers</h4>
                                <p className="mb-4 ff-secondary">Our Hypervisor runs on your choice of bare metal, turning any server into a Cloud platform in minutes.</p>

                                <Row>
                                    <Col sm={12}>
                                        <div className="vstack gap-2">
                                            <div className="d-flex">
                                                <div className="flex-shrink-0 me-3">
                                                    <FeatherIcon icon="shield" className="icon-dual-success" />
                                                </div>
                                                <div className="flex-grow-1">
                                                    <h5 className="fs-14 mb-3 mt-2">Solid Foundation</h5>
                                                    <p className='text-muted'>Built on KVM/QEMU; the underlying Virtualization technologies in the Gallium Hypervisor are stable and proven.</p>
                                                </div>
                                            </div>
                                            <div className="d-flex">
                                                <div className="flex-shrink-0 me-3">
                                                    <FeatherIcon icon="server" className="icon-dual-success" />
                                                </div>
                                                <div className="flex-grow-1">
                                                    <h5 className="fs-14 mb-3 mt-1">Deploy Anywhere</h5>
                                                    <p className='text-muted'>Because the Hypervisor is Cloud managed; it has no local surface area to secure, meaning you can deploy it anywhere with confidence.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                    
                                </Row>
                            </div>
                        </Col>

                        <Col lg={6} sm={7} className="col-10 ms-auto order-1 order-lg-2 d-none d-lg-block">
                            <div>
                                <img src={joinPage} alt="" className="img-fluid img-thumbnail mx-auto rounded" style={{maxWidth: "90%"}}/>
                            </div>
                            <Card className="card-bg-fill rounded shadow-lg d-none d-lg-block vm-list">
                                <img className="card-img img-fluid" src={joinCode} alt="Card cap">
                                </img>
                            </Card>
                        </Col>

                        <Col lg={6} sm={7} className="col-10 mx-auto order-1 order-lg-2 d-block d-lg-none">
                            <div>
                                <img src={joinCode} alt="" className="img-fluid img-thumbnail mx-auto rounded "/>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    );
};

export default Hypervisor;